import {useState, useEffect, useRef} from 'react';

export default function useComponentVisible(initialIsVisible: boolean, onClickOutside?: () => void) {
    const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
    const ref = useRef<any>(null);

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current?.contains(event.target)) {
                setIsComponentVisible(false);
                onClickOutside && onClickOutside();
            }
        };

        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, [onClickOutside]);

    return {ref, isComponentVisible, setIsComponentVisible};
}
